var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_10)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18_10",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 27
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 0H0V27H28V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1.93388C0 0.865685 0.9205 0 2.05625 0H25.9438C27.0795 0 28 0.865685 28 1.93388V25.0661C28 26.1343 27.0795 27 25.9438 27H2.05625C0.9205 27 0 26.1343 0 25.0661V1.93388ZM8.65025 22.6024V10.4102H4.4485V22.6024H8.65025ZM6.55025 8.74465C8.015 8.74465 8.92675 7.80975 8.92675 6.63863C8.9005 5.44219 8.01675 4.53263 6.57825 4.53263C5.13975 4.53263 4.2 5.44388 4.2 6.63863C4.2 7.80975 5.11175 8.74465 6.52225 8.74465H6.55025ZM15.1392 22.6024V15.7933C15.1392 15.4288 15.1672 15.0643 15.2792 14.8044C15.582 14.0771 16.2732 13.3228 17.4352 13.3228C18.956 13.3228 19.5632 14.4399 19.5632 16.0802V22.6024H23.765V15.6094C23.765 11.8631 21.693 10.1216 18.928 10.1216C16.6985 10.1216 15.6992 11.3029 15.1392 12.1348V12.177H15.1112C15.1206 12.1629 15.1299 12.1489 15.1392 12.1348V10.4102H10.9392C10.9918 11.5543 10.9392 22.6024 10.9392 22.6024H15.1392Z",
    fill: "#AED6DC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 27,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.f225b1be1c4d7f411495ad5ac6eeb5e4.svg";
export { ForwardRef as ReactComponent };